import script from "./Volume.vue?vue&type=script&lang=js"
export * from "./Volume.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__